import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

import useClientSocket from 'src/hooks/useClientSocket';

// ----------------------------------------------------------------------
// Thin layout for the new self-contained client pages.
// It runs the live client socket (useClientSocket) so the transfer widget's
// quotes and the transaction pages stay live, but renders NO header/footer —
// the page supplies its own (NewHeader / NewFooter inside each page).
// ----------------------------------------------------------------------

export default function NewClientLayout({ children }) {
  useClientSocket();

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>{children}</Box>
  );
}

NewClientLayout.propTypes = {
  children: PropTypes.node,
};
